import React, { Component } from 'react';
import ChatComponent from '../FloatingSideComponents/ChatComponent';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { DRAGGABLE_WINDOWS } from '../../../constants'

export default class SupervisorChatExpanded extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
  }
  shouldComponentUpdate(next_props, next_state) {
    return false;
  }  

  render() {
    return (
      <div
        className={"fullSize " + (this.sharedData.getWindowExpandedActive() !== DRAGGABLE_WINDOWS.SUPERVISOR_CHAT ? "height0" : "")}
        key="supervisorChatWindow">
        <ChatComponent floating={false} objProps={this.props.objProps} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/workSpace/ExpandedBar/SupervisorChatExpanded.jsx